<template>
  <div class="container sv046">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne>お借り入れについて</HeadingOne>

    <p>
      パソコン・スマートフォンから簡単にお手続きが可能！お客さまに合ったお借り入れ方法をお選びいただけます。
    </p>

    <section>
      <HeadingTwo>お借り入れ方法</HeadingTwo>

      <div class="row _mb-md-120 _mb-sm-60">
        <CardLink
          class="col-md-6 _mb-md-30 _mb-sm-10"
          title="au PAY 残高にチャージ"
          src="sv/sv046/img01.gif"
          router-name="sv024"
          badge=""
        >
          au PAY 残高にチャージします。チャージした残高は、au PAY
          プリペイドカードやau PAYでご利用いただけます。
        </CardLink>
        <CardLink
          class="col-md-6 _mb-md-30 _mb-sm-10"
          title="ご登録口座へのお振込み"
          src="sv/sv046/img02.gif"
          router-name="sv023"
          badge=""
        >
          ご登録いただいたご本人さま名義の口座へお振込みします。お手続き完了後は、キャッシュカード等でお引き出しいただけます。
        </CardLink>
        <CardLink
          class="col-md-6"
          title="セブン銀行スマホATM"
          src="sv/sv046/img03.gif"
          router-name="sv025"
          badge=""
        >
          au PAY
          スマートローンアプリをインストールすると、全国のセブン銀行ATMでカードレスでお借り入れいただけます。
        </CardLink>
      </div>
    </section>

    <section>
      <HeadingTwo>お利息のご案内</HeadingTwo>

      <p class="_mb-md-60">
        お借り入れ利率やお利息の計算方法についてはこちらからご確認いただけます。
      </p>

      <BtngroupSingle class="_mb-md-120 _mb-sm-60">
        <BtnMain class="-normal" router-name="sv022"> お利息のご案内 </BtnMain>
      </BtngroupSingle>
    </section>

    <CvBox class="_mb-md-120 _mb-sm-60" />

    <ContactBox class="_mb-md-120 _mb-sm-60" />
  </div>
  <!-- container -->
</template>

<script>
import { setMeta } from "@/utils/Meta";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import HeadingOne from "@/components/heading/HeadingOne";
import HeadingTwo from "@/components/heading/HeadingTwo";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import ContactBox from "@/components/box/ContactBox";
import CvBox from "@/components/box/CvBox";
// import CardBox from '@/components/card/CardBox'
// import CardHeader from '@/components/card/CardHeader'
// import CardBody from '@/components/card/CardBody'
// import ListGroup from '@/components/list/ListGroup'
// import ListItem from '@/components/list/ListItem'
import CardLink from "@/components/card/CardLink";

export default {
  name: "Sv046",
  components: {
    BreadcrumbGroup,
    CardLink,
    // ListItem,
    // ListGroup,
    // CardBody,
    // CardHeader,
    // CardBox,
    CvBox,
    ContactBox,
    BtnMain,
    BtngroupSingle,
    HeadingOne,
    HeadingTwo,
  },
  setup() {
    setMeta({
      title: "お借り入れについて",
      description:
        "au PAY スマートローンでのお借り入れ方法についてご案内します。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "お借り入れについて",
          active: true,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
